import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';
import FAQs from './pages/FAQs';
import Locations from './pages/Locations';
import Blog from './pages/Blog';
import Services from './pages/Services';
import GetAQuote from './pages/GetAQuote';
import BlogPost from './pages/BlogPost';
import './App.css';
import ReviewForm from './pages/ReviewForm';

export default function App() {
  const [shrink, setShrink] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShrink(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Router>
      <nav className={`navbar navbar-expand-lg navbar-dark bg-primary px-4 sticky-top shadow-sm ${shrink ? 'navbar-shrink' : ''}`}>
        <NavLink className="navbar-brand" to="/">
          <img
            src="/Jazuz-logo.jpg"
            alt="Jazuz logo"
            className="me-3 logo-img"
            style={{ height: shrink ? '50px' : '70px', transition: 'height 0.3s ease' }}
          />
        </NavLink>

        <div className="navbar-nav d-flex w-100">
          <div className="d-flex">
            <NavLink
              to="/"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
              end
            >
              <i className="bi bi-house-door me-1"></i> Home
            </NavLink>
            <NavLink
              to="/about"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
            >
              <i className="bi bi-info-circle me-1"></i> About Us
            </NavLink>
            <NavLink
              to="/contact"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
            >
              <i className="bi bi-envelope me-1"></i> Contact Us
            </NavLink>
            <NavLink
              to="/faqs"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
            >
              <i className="bi bi-question-circle me-1"></i> FAQs
            </NavLink>
            <NavLink
              to="/locations"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
            >
              <i className="bi bi-geo-alt me-1"></i> Locations
            </NavLink>
            <NavLink
              to="/services"
              className={({ isActive }) => isActive ? "nav-link active-link" : "nav-link"}
            >
              <i className="bi bi-truck me-1"></i> Services
            </NavLink>
          </div>

          <div className="d-flex ms-auto">
            <NavLink
              to="/quote"
              className={({ isActive }) =>
                isActive
                  ? "nav-link fw-bold text-warning active-link"
                  : "nav-link fw-bold text-white"
              }
            >
              <i className="bi bi-file-earmark-text me-1"></i> Get a Quote
            </NavLink>
            <NavLink
              to="/blog"
              className={({ isActive }) =>
                isActive
                  ? "nav-link fw-bold text-warning active-link"
                  : "nav-link fw-bold text-white"
              }
            >
              <i className="bi bi-journal-text me-1"></i> Blog
            </NavLink>
          </div>
        </div>
      </nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/locations" element={<Locations />} />
        <Route path="/services" element={<Services />} />
        <Route path="/quote" element={<GetAQuote />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
        <Route path="/review" element={<ReviewForm />} />
      </Routes>
    </Router>
  );
}
